(ns app.front.view.group.admin.public-notice-template-editor
  (:require [app.domain.party-role.model :as role-model]
            [app.domain.public-notice.template-config :as public-notice-config]
            [app.front.entities :as entities]
            [app.front.file.download :as file-download]
            [app.front.ui.multi-select :as ui-ms]
            [app.front.ui.template-editor :as template-editor]
            [app.front.ui.text-editor :as text-editor]
            [app.front.util :refer [for-frag]]
            [app.front.view.group.admin.review-config :as review-config]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.admin.templates.document-editor :as document-editor]
            [app.front.view.group.subs :as group-subs]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(defn do-save [data]
  {:comm/command {:command    :public-notice/save-template
                  :method     :post
                  :notify     {:success :public-notice/template-saved}
                  :on-success [::save-success]
                  :data       data}})


(rf/reg-event-fx ::save-success
  (fn [_ [_ status db-changes]]
    {:dispatch-n [[::entities/apply-changes status db-changes]]}))


(rf/reg-event-fx ::save
  (fn [_ [_ authority-group-id html css extra-data]]
    (do-save (merge {:authority-group-id authority-group-id}
                    (util/assoc-when {}
                                     :html html
                                     :css css)
                    extra-data))))


(defn party-toggle-box [tr group-id template inherited?]
  (when template
    (let [lang           (<sub [:language])
          party-roles    (if (<sub [::gas/superdomain-group?])
                           (<sub [::group-subs/descendant-available-party-roles
                                  (<sub [::gas/descendant-authority-group-ids])
                                  :permit-type/P])
                           (<sub [::group-subs/available-party-roles group-id]))
          selected-roles (set (some-> template :public-notice-document.template/party-role-keys))]
      [:div.pt-2
       (cc/accordion
         {}
         (cc/accordion-item
           {:title (tr [:public-notice/parties-available])}
           [ui-ms/multi-checkbox {:id        (name :public-notice-document.template/party-role-keys)
                                  :tr        tr
                                  :values    (map :party-role/key party-roles)
                                  :selected  selected-roles
                                  :disabled  (when inherited? (->> party-roles (map :party-role/key) set))
                                  :val->str  #(or (some->> party-roles
                                                           (p/find-first {:party-role/key %})
                                                           (role-model/party-role-name lang))
                                                  (tr [%]))
                                  :on-change #(>evt [::save group-id nil nil {:party-role-keys (vec %)}])}]))])))


(defn view [tr group-id template inherited? replace-template]
  (let [{:public-notice-document.template/keys
         [html-template
          print-css]}                          template
        images                                 (<sub [::gas/verdict-images group-id])
        review-placeholder-options             {:review-configs (<sub [::review-config/available-review-configs group-id])}]
    [:<>
     [template-editor/editor
      (-> (util/mmap {:read-only?   inherited?
                      :on-save      #(>evt [::save group-id %1 %2 nil])
                      :title        [:h3 (tr [:public-notice/template])]
                      :preview-url  (file-download/download-href
                                      :group/generate-public-notice-template-preview-pdf
                                      {:group-id group-id})
                      :placeholders (public-notice-config/public-notice-picker-variables (<sub [::ff/enabled-flags]))}
                     html-template replace-template print-css tr images review-placeholder-options)
          (text-editor/with-external-edit-state ::main))
      (for-frag [{:keys [db-reference] :as snippet-config}
                 public-notice-config/party-snippet-configs
                 :let [children    (case db-reference
                                     :public-notice-document.template/party-snippet
                                     [[party-toggle-box tr group-id template inherited?]]
                                     nil)]]
        ^{:key (str db-reference)}
        [:div.mt-4
         (into
           [document-editor/editor-for-snippet snippet-config
            (util/mmap
              {:get-db-snippet  (partial get template)
               :save-db-snippet (fn [[db-reference html]]
                                  (>evt [::save group-id nil nil {(-> db-reference name keyword) html}]))}
              tr group-id)]
           children)])]]))
